import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import { sortNonActivatedSims } from '../../utils/helpers';

import {
  SIMS_FETCH,
  SIMS_RECEIVE,
  CURRENT_ORDER_FETCH,
  CURRENT_ORDER_RECEIVE,
  UPDATE_ORDER_FINISHED,
  CURRENT_SIM_FETCH,
  CURRENT_SIM_RECEIVE,
  CURRENT_SIM_CLEAR,
  NON_ACTIVATED_SIMS_RECEIVE,
  NON_ACTIVATED_SIMS_FETCH,
} from './constants'

const initialState = fromJS({
  fetching: false,
  currentSimFetchFinished: false,
  ready: false,
  orderReady: false,
  entities: {},
  result: null,
  currentOrder: null,
  simReady: false,
  currentSim: null,
  updateOrderFinished: false,
  nonActivatedSims: [],
  nonActivatedSimsFetching: false,
});

export const reducer = handleActions({
  [NON_ACTIVATED_SIMS_FETCH]: (state) => (
    state
      .set('nonActivatedSimsFetching', true)
  ),

  [SIMS_FETCH]: (state) => (
    state
      .set('fetching', true)
  ),

  [SIMS_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('ready', true)
      .set('entities', fromJS(action.payload.entities))
      .set('result', fromJS(action.payload.result))
  ),

  [CURRENT_ORDER_FETCH]: (state) => (
    state
      .set('fetching', true)
  ),


  [CURRENT_ORDER_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('ready', true)
      .set('orderReady', true)
      .set('currentOrder', fromJS(action.payload.order))
  ),

  [CURRENT_SIM_FETCH]: (state) => (
    state
      .set('fetching', true)
      .set('currentSimFetchFinished', false)
  ),

  [CURRENT_SIM_CLEAR]: (state) => (
    state
      .set('currentSim', null)
  ),

  [CURRENT_SIM_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('currentSimFetchFinished', true)
      .set('ready', true)
      .set('simReady', true)
      .set('currentSim', fromJS(action.payload.currentSim))
  ),

  [UPDATE_ORDER_FINISHED]: (state) => (
    state
      .set('updateOrderFinished', true)
  ),

  [NON_ACTIVATED_SIMS_RECEIVE]: (state, action) => (
    state
      .set('nonActivatedSimsFetching', false)
      .set('nonActivatedSims', fromJS(sortNonActivatedSims(action.payload.nonActivatedSims)))
  ),

}, initialState);

export default reducer
